import type { CommandAction } from '../../CommandPalette'
import type { BuildCommandActionsContext } from './types'

export const buildNavigationCoreActions = ({ t, setSection }: BuildCommandActionsContext): CommandAction[] => [
  {
    id: 'nav-dashboard',
    name: t('command.nav.dashboard'),
    keywords: 'home riepilogo overview',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.dashboard.subtitle'),
    perform: () => setSection('dashboard'),
  },
  {
    id: 'nav-support-inbox',
    name: t('command.nav.supportInbox'),
    keywords: 'supporto assistenza ticket inbox clienti email comunicazioni',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.supportInbox.subtitle'),
    perform: () => setSection('support-inbox'),
  },
  {
    id: 'nav-slider',
    name: t('command.nav.slider'),
    keywords: 'slider hero immagini',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.slider.subtitle'),
    perform: () => setSection('slider'),
  },
  {
    id: 'nav-pages',
    name: t('command.nav.pages'),
    keywords: 'pagine contenuti cms',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.pages.subtitle'),
    perform: () => setSection('pages'),
  },
  {
    id: 'nav-site-branding',
    name: t('command.nav.site.branding'),
    keywords: 'impostazioni sito brand homepage favicon logo',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.branding.subtitle'),
    perform: () => setSection('site-branding'),
  },
  {
    id: 'nav-themes',
    name: t('command.nav.themes'),
    keywords: 'theme temi design token palette colori font',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.themes.subtitle'),
    perform: () => setSection('themes'),
  },
  {
    id: 'nav-site-footer',
    name: t('command.nav.site.footer'),
    keywords: 'impostazioni sito footer link note',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.footer.subtitle'),
    perform: () => setSection('site-footer'),
  },
  {
    id: 'nav-site-legal',
    name: t('command.nav.site.legal'),
    keywords: 'impostazioni sito privacy cookie termini policy',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.legal.subtitle'),
    perform: () => setSection('site-legal'),
  },
  {
    id: 'nav-site-contact',
    name: t('command.nav.site.contact'),
    keywords: 'impostazioni sito contatti telefono email social facebook instagram',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.contact.subtitle'),
    perform: () => setSection('site-contact'),
  },
  {
    id: 'nav-site-email-templates',
    name: t('command.nav.site.emailTemplates'),
    keywords: 'comunicazioni email template anteprima placeholder',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.emailTemplates.subtitle'),
    perform: () => setSection('site-email-templates'),
  },
  {
    id: 'nav-site-email-logs',
    name: t('command.nav.site.emailLogs'),
    keywords: 'comunicazioni email log invii test smtp errori',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.emailLogs.subtitle'),
    perform: () => setSection('site-email-logs'),
  },
  {
    id: 'nav-site-payments',
    name: t('command.nav.site.payments'),
    keywords: 'impostazioni stripe pagamenti checkout webhook chiavi',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.site.payments.subtitle'),
    perform: () => setSection('site-payments'),
  },
  {
    id: 'nav-system-status',
    name: t('command.nav.systemStatus'),
    keywords: 'stato servizi health uptime',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.systemStatus.subtitle'),
    perform: () => setSection('system-status'),
  },
  {
    id: 'nav-updates',
    name: t('command.nav.updates'),
    keywords: 'release deploy rollback platform updates',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.updates.subtitle'),
    perform: () => setSection('updates'),
  },
  {
    id: 'nav-feature-flags',
    name: t('command.nav.featureFlags'),
    keywords: 'feature flags rollout toggle runtime sicurezza',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.featureFlags.subtitle'),
    perform: () => setSection('feature-flags'),
  },
  {
    id: 'nav-audit-logs',
    name: t('command.nav.auditLogs'),
    keywords: 'audit log sicurezza eventi operazioni admin',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.auditLogs.subtitle'),
    perform: () => setSection('audit-logs'),
  },
  {
    id: 'nav-audit-trail',
    name: t('command.nav.auditTrail'),
    keywords: 'audit trail pagamenti stripe webhook checkout runtime eventi',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.auditTrail.subtitle'),
    perform: () => setSection('audit-trail'),
  },
  {
    id: 'nav-menu',
    name: t('command.nav.menu'),
    keywords: 'menu link navigazione',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.menu.subtitle'),
    perform: () => setSection('menu'),
  },
]
